__turbopack_context__.v({
  "className": "montserrat_c5a0b145-module__19wr9q__className",
  "variable": "montserrat_c5a0b145-module__19wr9q__variable",
});
